import React, { useEffect, useState } from "react";

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden noise pb-20"
    >
      {/* Gradient Background */}
      <div className="absolute inset-0 z-0 gradient-mesh animate-gradient"></div>

      {/* Animated Orbs */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 -left-20 w-[500px] h-[500px] bg-white/10 rounded-full blur-3xl animate-float"></div>
        <div
          className="absolute bottom-20 -right-20 w-[600px] h-[600px] bg-white/10 rounded-full blur-3xl animate-float"
          style={{ animationDelay: "2s" }}
        ></div>
        <div
          className="absolute top-1/2 left-1/2 w-[400px] h-[400px] bg-white/5 rounded-full blur-3xl animate-float"
          style={{ animationDelay: "4s" }}
        ></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-12 z-10 pt-32">
        <div className="text-center text-white">
          <div
            className={`transition-all duration-1000 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-20"
            }`}
          >
            {/* Logo */}
            <div className="mb-12 flex justify-center">
              <img
                src="/assets/images/logo_putih_besar.png"
                alt="BMX Logo"
                className="w-80 h-80 lg:w-[450px] lg:h-[450px] object-contain animate-scaleIn drop-shadow-2xl"
              />
            </div>

            <h1
              className="text-3xl lg:text-5xl mb-6 animate-fadeInUp font-light tracking-wide"
              style={{ animationDelay: "0.2s" }}
            >
              Kiriman Datang Sesuai Harapan
            </h1>
            <p
              className="text-xl lg:text-2xl mb-12 text-white/80 animate-fadeInUp italic font-light"
              style={{ animationDelay: "0.3s" }}
            >
              Shipment Arrived as Expected
            </p>

            <div
              className="flex flex-col sm:flex-row gap-6 justify-center items-center animate-fadeInUp"
              style={{ animationDelay: "0.4s" }}
            >
              <a
                href="#services"
                className="px-10 py-5 bg-white text-primary rounded-full font-bold text-sm uppercase tracking-wider btn-premium shadow-2xl"
              >
                Lihat Layanan Kami
              </a>
              <a
                href="#contact"
                className="px-10 py-5 glass border-2 border-white text-white rounded-full font-bold text-sm uppercase tracking-wider btn-premium"
              >
                Hubungi Kami
              </a>
            </div>
          </div>

          {/* Stats - WARNA PUTIH + MARGIN BOTTOM */}
          <div className="mt-24 mb-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                number: "7+",
                label: "Tahun Pengalaman",
                sublabel: "Years of Excellence",
              },
              {
                number: "500+",
                label: "Pengiriman Sukses",
                sublabel: "Successful Deliveries",
              },
              {
                number: "100%",
                label: "Kepuasan Customer",
                sublabel: "Customer Satisfaction",
              },
            ].map((stat, index) => (
              <div
                key={index}
                className="glass rounded-3xl p-8 card-premium animate-fadeInUp border border-white/20"
                style={{ animationDelay: `${0.6 + index * 0.15}s` }}
              >
                {/* NUMBER WARNA PUTIH */}
                <div className="text-6xl lg:text-7xl font-bold mb-3 text-white">
                  {stat.number}
                </div>
                <div className="text-lg font-semibold mb-1 text-white">
                  {stat.label}
                </div>
                <div className="text-sm text-white/70 italic">
                  {stat.sublabel}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 border-2 border-white rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
